import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import TrustBar from "./components/TrustBar";
import Services from "./components/Services";
import About from "./components/About";
import Areas from "./components/Areas";
import Reviews from "./components/Reviews";
import CTABanner from "./components/CTABanner";
import Footer from "./components/Footer";
import BookingModal from "./components/BookingModal";
import ServiceDetailModal from "./components/ServiceDetailModal";
import PropertyTypes from "./components/PropertyTypes";
import { Toaster } from "./components/ui/toaster";
import { Phone } from "lucide-react";
import { COMPANY } from "./mock";

// Admin
import { AdminAuthProvider } from "./admin/AuthContext";
import AdminLogin from "./admin/AdminLogin";
import AdminLayout from "./admin/AdminLayout";
import AdminDashboard from "./admin/AdminDashboard";
import AdminBookings from "./admin/AdminBookings";
import AdminCalendar from "./admin/AdminCalendar";
import AdminCustomers from "./admin/AdminCustomers";
import AdminMessages from "./admin/AdminMessages";
import AdminConversations from "./admin/AdminConversations";
import AdminCommunications from "./admin/AdminCommunications";
import AdminTemplates from "./admin/AdminTemplates";

function PublicHome() {
  const [bookingOpen, setBookingOpen] = useState(false);
  const [defaultService, setDefaultService] = useState(null);
  const [defaultQuoteId, setDefaultQuoteId] = useState(null);
  const [detailOpen, setDetailOpen] = useState(false);
  const [detailService, setDetailService] = useState(null);
  const openBooking = (service = null) => {
    setDefaultService(service);
    setDefaultQuoteId(null);
    setBookingOpen(true);
  };

  const openBookingQuote = (propertyType) => {
    setDefaultService(null);
    setDefaultQuoteId(`quote-${propertyType.id}`);
    setBookingOpen(true);
  };

  const openDetails = (service) => {
    setDetailService(service);
    setDetailOpen(true);
  };

  return (
    <div className="min-h-screen bg-white">
      <Header onBookNow={() => openBooking()} />
      <Hero onBookNow={() => openBooking()} />
      <TrustBar />
      <Services onBookService={(s) => openBooking(s)} onViewDetails={(s) => openDetails(s)} />
      <About onBookNow={() => openBooking()} />
      <PropertyTypes onGetQuote={(p) => openBookingQuote(p)} />
      <Areas />
      <Reviews />
      <CTABanner onBookNow={() => openBooking()} />
      <Footer />

      <a
        href={`tel:${COMPANY.phoneLink}`}
        className="lg:hidden fixed bottom-5 right-5 z-40 w-14 h-14 rounded-full bg-sky-600 text-white flex items-center justify-center shadow-2xl pulse-ring"
        aria-label="Call now"
      >
        <Phone size={22} />
      </a>

      <BookingModal
        open={bookingOpen}
        onOpenChange={setBookingOpen}
        defaultService={defaultService}
        defaultQuoteId={defaultQuoteId}
      />
      <ServiceDetailModal
        open={detailOpen}
        onOpenChange={setDetailOpen}
        service={detailService}
        onBook={(s) => openBooking(s)}
      />
      <Toaster />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PublicHome />} />
          <Route
            path="/admin/*"
            element={
              <AdminAuthProvider>
                <Routes>
                  <Route path="login" element={<AdminLogin />} />
                  <Route path="/" element={<AdminLayout />}>
                    <Route index element={<AdminDashboard />} />
                    <Route path="bookings" element={<AdminBookings />} />
                    <Route path="calendar" element={<AdminCalendar />} />
                    <Route path="customers" element={<AdminCustomers />} />
                    <Route path="messages" element={<AdminMessages />} />
                    <Route path="conversations" element={<AdminConversations />} />
                    <Route path="communications" element={<AdminCommunications />} />
                    <Route path="templates" element={<AdminTemplates />} />
                  </Route>
                </Routes>
              </AdminAuthProvider>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
